import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { CONTACT_INFO } from "../mock";
import { Phone, Mail, MapPin, Heart, Instagram } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-brand-plumDark text-brand-cream">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-serif text-2xl mb-2">Francesca De Salvia</p>
          <p className="text-xs tracking-[0.3em] uppercase text-brand-gold mb-4">
            Pranic Healing
          </p>
          <p className="text-brand-cream/70 text-sm leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div className="space-y-3">
          <a href={CONTACT_INFO.phoneHref} className="flex items-center gap-3 text-brand-cream/80 hover:text-brand-goldLight transition-colors">
            <Phone size={17} className="text-brand-gold" /> {CONTACT_INFO.phone}
          </a>
          <a href={`mailto:${CONTACT_INFO.email}`} className="flex items-center gap-3 text-brand-cream/80 hover:text-brand-goldLight transition-colors">
            <Mail size={17} className="text-brand-gold" /> {CONTACT_INFO.email}
          </a>
          <p className="flex items-center gap-3 text-brand-cream/80">
            <MapPin size={17} className="text-brand-gold" /> {CONTACT_INFO.addressFull}
          </p>
          <a href={CONTACT_INFO.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-brand-cream/80 hover:text-brand-goldLight transition-colors">
            <Instagram size={17} className="text-brand-gold" /> @francescadesalvia
          </a>
        </div>

        <div>
          <p className="text-brand-cream/60 text-xs leading-relaxed">{t.footer.disclaimer}</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-brand-cream/50 text-xs">
          <p>© {year} Francesca De Salvia. {t.footer.rights}</p>
          <p className="flex items-center gap-1.5">
            Made with <Heart size={12} className="text-brand-gold" /> in Tenerife
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
